import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=38c66eb2&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=38c66eb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c66eb2",
  null
  
)

export default component.exports